import React, { useState, useEffect, useContext } from 'react'
import { toast } from 'react-toastify';
import {
  getProductMaster,
  create_product_details,
  get_product_details,
  update_product_details,
  delete_product_details
} from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";
import { NaviGate } from "../../../Utility/function";

const Pod_details = () => {
  const { showLoader, hideLoader, UserItem, shopItem, selectedWarehouse, warehouse } = useContext(WarehouseContext);

  // State management
  const [products, setProducts] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  // Form data
  const [formData, setFormData] = useState({
    p_id: '',
    p_code: '',
    p_weight: '',
    // warehouse_id: selectedWarehouse?.id || '',
    branch_id: '',
    shop_id: shopItem?.shop_id || '',
    p_price: '',
    pbox_qty: '',
    pbox_unit: '',
    pbox_code: '',
    pbox_price: '',
    created_by: UserItem?.user_id || ''
  });

  // Form errors
  const [errors, setErrors] = useState({});

  // Fetch data on component mount
  useEffect(() => {
    fetchProducts();
    fetchProductDetails();
  }, []);

  // Fetch products list
  const fetchProducts = async () => {
    showLoader();
    try {
      const response = await getProductMaster();
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("Failed to fetch products");
    } finally {
      hideLoader();
    }
  };

  // Fetch product details
  const fetchProductDetails = async (page = 1, text = "") => {
    showLoader();
    try {
      const params = {
        shop_id: shopItem?.shop_id || "0",
        // ware_id: warehouse?.id || "1",
        page,
        search: text,
      };

      const response = await get_product_details(params);

      if (response.data && response.data.data) {
        setProductDetails(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      toast.error("Failed to fetch product details");
    } finally {
      hideLoader();
    }
  };


  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    // Clear error when field is changed
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  // Handle product selection
  const handleProductSelect = (e) => {
    const productId = e.target.value;
    setFormData({
      ...formData,
      p_id: productId
    });

    // Find selected product
    const product = products.find(p => p.product_id.toString() === productId);
    setSelectedProduct(product);

    if (product) {
      // Pre-fill form with product data
      setFormData(prev => ({
        ...prev,
        p_id: productId,
        p_code: product.product_code || '',
        pbox_unit: product.unit || '',
        p_weight: isEditMode ? prev.p_weight : '',  // Keep weight if editing
        p_price: product.sales_price || '',
        pbox_qty: product.box_qty || '',
        pbox_code: product.box_barcode || '',
        pbox_price: product.box_sales || '',
        reorder_point: product.reorder_point || '',
      }));
    }
  };

  const handleEdit = (detail) => {
    setIsEditMode(true);
    setSelectedDetail(detail);

    setFormData({
      id: detail.id,
      p_id: detail.p_id || '',
      p_code: detail.p_code || '',
      p_weight: detail.p_weight || '',
      // warehouse_id: detail.warehouse_id || selectedWarehouse?.id || '',
      branch_id: detail.branch_id || '',
      shop_id: detail.shop_id || shopItem?.shop_id || '',
      p_price: detail.p_price || '',
      pbox_qty: detail.pbox_qty || '',
      pbox_unit: detail.pbox_unit || '',
      pbox_code: detail.pbox_code || '',
      pbox_price: detail.pbox_price || '',
      reorder_point: detail.reorder_point || '',
      created_by: detail.created_by || UserItem?.user_id || ''
    });

    const product = products.find(p => p.product_id.toString() === detail.p_id);
    setSelectedProduct(product);
    setShowDetailsModal(true);
  };

  const handleDeleteClick = (detail) => {
    setSelectedDetail(detail);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    if (!selectedDetail) return;

    showLoader();
    try {
      const response = await delete_product_details(selectedDetail.id);

      if (response.data && response.data.status === 'success') {
        toast.success("Product detail deleted successfully");
        setShowDeleteModal(false);
        fetchProductDetails(); // Refresh list
      } else {
        toast.error(response.data?.message || "Failed to delete product detail");
      }
    } catch (error) {
      console.error("Error deleting product detail:", error);
      toast.error(error?.response?.data?.message || "Error deleting product detail");
    } finally {
      hideLoader();
    }
  };



  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.p_id) newErrors.p_id = "Product selection is required";
    if (!formData.p_weight) newErrors.p_weight = "Weight is required";
    if (!formData.p_price) newErrors.p_price = "Price is required";
    if (!formData.pbox_unit) newErrors.pbox_unit = "Unit is required";
    // pbox_qty, pbox_code, pbox_price, reorder_point are optional

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    showLoader();

    try {
      let response;

      if (isEditMode) {
        response = await update_product_details(formData.id, formData);
        // response = await (formData);
      } else {
        response = await create_product_details(formData);
      }

      if (response.data && response.data.status === 'success') {
        toast.success(isEditMode ? "Product details updated successfully" : "Product details added successfully");
        resetForm();
        setShowDetailsModal(false);
        fetchProductDetails();
      } else {
        toast.error(response.data?.message || (isEditMode ? "Failed to update product details" : "Failed to add product details"));
      }
    } catch (error) {
      console.error(isEditMode ? "Error updating product details:" : "Error adding product details:", error);
      toast.error(error?.response?.data?.message || (isEditMode ? "Error updating product details" : "Error adding product details"));
    } finally {
      setLoading(false);
      hideLoader();
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      p_id: '',
      p_code: '',
      p_weight: '',
      // warehouse_id: selectedWarehouse?.id || '',
      branch_id: '',
      shop_id: shopItem?.shop_id || '',
      p_price: '',
      pbox_qty: '',
      pbox_unit: '',
      pbox_code: '',
      pbox_price: '',
      reorder_point: '',
      created_by: UserItem?.user_id || ''
    });
    setSelectedProduct(null);
    setSelectedDetail(null);
    setIsEditMode(false);
    setErrors({});
  };

  // Format date for display
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />

        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>
            Product Packs
          </h6>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              resetForm(); // Clear form before opening
              setShowDetailsModal(true);
            }}
          >
            Add Product Packs
          </button>
        </div>
        <hr className="mt-1" />

        {/* Product Details Table */}
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Product Code</th>
                    <th>Product</th>
                    <th>Weight</th>
                    <th>Price (INR)</th>
                    <th>Box Qty</th>
                    {/* <th>Box Unit</th> */}
                    <th>Box Code</th>
                    <th>Box Price (INR)</th>
                    <th>Reorder Point</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {productDetails.length > 0 ? (
                    productDetails.map((detail, index) => (
                      <tr key={detail.id}>
                        <td>{index + 1}</td>
                        <td>{detail.p_code}</td>
                        <td>
                          {products.find(p => p.product_id.toString() === detail.p_id)?.title ||
                            `Product #${detail.p_id}`}
                        </td>
                        <td>{detail.p_weight} {detail.pbox_unit}</td>
                        <td>₹{detail.p_price}</td>
                        <td>{detail.pbox_qty}</td>
                        {/* <td>{detail.pbox_unit}</td> */}
                        <td>{detail.pbox_code}</td>
                        <td>₹{detail.pbox_price}</td>
                        <td>{detail.reorder_point}</td>
                        <td>

                          <>
                            <img
                              src="/assets/images/icons/edit.png"
                              onClick={() => handleEdit(detail)}

                              height="16px"
                              alt="Edit"
                            />
                            &nbsp;&nbsp;&nbsp;
                            <img
                              src="/assets/images/icons/delete.png"
                              onClick={() => handleDeleteClick(detail)}
                              height="16px"
                              alt="Delete"
                            />
                          </>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">
                        No product details found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Add/Edit Details Modal */}
        {showDetailsModal && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{isEditMode ? 'Edit Product Packs' : 'Add Product Packs'}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowDetailsModal(false);
                      resetForm();
                    }}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      {/* Product Selection */}
                      <div className="col-md-6"  >
                        <label className="form-label">Select Product <span className="text-danger">*</span></label>
                        <select
                          name="p_id"
                          value={formData.p_id}
                          onChange={handleProductSelect}
                          className={`form-control ${errors.p_id ? 'is-invalid' : ''}`}
                          disabled={isEditMode}
                        >
                          <option value="">Select Product</option>
                          {products.map(product => (
                            <option key={product.product_id} value={product.product_id}>
                              {product.title}
                            </option>
                          ))}
                        </select>
                        {errors.p_id && <div className="invalid-feedback">{errors.p_id}</div>}
                      </div>
                      {/* Product Code */}
                      <div className="col-md-6">
                        <label className="form-label">Product Code</label>
                        <input
                          type="text"
                          name="p_code"
                          value={formData.p_code}
                          onChange={handleInputChange}
                          className="form-control"

                        />
                      </div>

                      <div className="row mx-1 mt-1 mb-2">


                        {/* Product Weight */}
                        <div className="col-md-6 mb-1">
                          <label className="form-label">P_Weight <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            name="p_weight"
                            value={formData.p_weight}
                            onChange={handleInputChange}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                              const parts = e.target.value.split('.');
                              if (parts.length > 2) {
                                e.target.value = parts[0] + '.' + parts.slice(1).join('');
                              }
                              if (parts[1] && parts[1].length > 2) {
                                e.target.value = parts[0] + '.' + parts[1].substring(0, 2);
                              }
                            }}
                            inputMode='decimal'
                            pattern="[0-9]*\.?[0-9]{0,2}"
                            placeholder="0.00"
                            className={`form-control ${errors.p_weight ? 'is-invalid' : ''}`}
                          />
                          {errors.p_weight && <div className="invalid-feedback">{errors.p_weight}</div>}
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Unit <span className="text-danger">*</span></label>
                          <select
                            name="pbox_unit"
                            value={formData.pbox_unit}
                            onChange={handleInputChange}
                            className={`form-control ${errors.pbox_unit ? 'is-invalid' : ''}`}
                          >
                            <option value="">Select Unit</option>
                            <option value="kilograms">Kilograms</option>
                            <option value="grams">Grams</option>
                            {/* <option value="liters">Liters</option>
                            <option value="milliliters">Milliliters</option>
                            <option value="pcs">Pieces</option> */}
                          </select>
                          {errors.pbox_unit && <div className="invalid-feedback">{errors.pbox_unit}</div>}
                        </div>
                        {/* Product Price */}
                        <div className="col-md-6 mb-1">
                          <label className="form-label">Price (INR) <span className="text-danger">*</span></label>
                          <input
                            name="p_price"
                            value={formData.p_price}
                            onChange={handleInputChange}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                              const parts = e.target.value.split('.');
                              if (parts.length > 2) {
                                e.target.value = parts[0] + '.' + parts.slice(1).join('');
                              }
                              if (parts[1] && parts[1].length > 2) {
                                e.target.value = parts[0] + '.' + parts[1].substring(0, 2);
                              }
                            }}
                            inputMode='decimal'
                            pattern="[0-9]*\.?[0-9]{0,2}"
                            placeholder="0.00"
                            className={`form-control ${errors.p_price ? 'is-invalid' : ''}`}
                            min="0"
                            step="0.01"
                          />
                          {errors.p_price && <div className="invalid-feedback">{errors.p_price}</div>}
                        </div>
                      </div>

                      {/* Box Quantity */}
                      <div className="row mx-1 pt-3">

                        <div className="col-md-6">
                          <label className="form-label">Box Quantity</label>
                          <input
                            type="number"
                            name="pbox_qty"
                            value={formData.pbox_qty}
                            onChange={handleInputChange}
                            className="form-control"
                            min="1"
                          />
                        </div>
                        {/* Box Unit */}



                        {/* Box Code */}
                        <div className="col-md-6 mb-2">
                          <label className="form-label">Box Code</label>
                          <input
                            type="text"
                            name="pbox_code"
                            value={formData.pbox_code}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>

                        {/* Box Price */}
                        <div className="col-md-6 mb-2">
                          <label className="form-label">Box Price (INR)</label>
                          <input
                            type="number"
                            name="pbox_price"
                            value={formData.pbox_price}
                            onChange={handleInputChange}
                            className="form-control"
                            min="0"
                            step="0.01"
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Reorder Point</label>
                          <input
                            type="text"
                            name="reorder_point"
                            value={formData.reorder_point}
                            onChange={handleInputChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="text-end mt-4">
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        onClick={() => {
                          setShowDetailsModal(false);
                          resetForm();
                        }}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? 'Saving...' : isEditMode ? 'Update Details' : 'Save Details'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {showDeleteModal && selectedDetail && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
            <div className="modal-dialog modal-md">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                  ></button>
                </div>

                <div className="modal-body text-center">
                  <i className="bi bi-exclamation-triangle text-danger fs-1 d-block mb-3"></i>

                  {/* PRODUCT DETAIL LINE */}
                  <p className="fw-bold">
                    {products.find(p => p.product_id.toString() === selectedDetail.p_id)?.title}
                    {" — "}
                    {selectedDetail.p_weight} {selectedDetail.pbox_unit} Remaining QTY {selectedDetail.p_qty || 0}
                  </p>

                  <p className="mt-2">
                    Are you sure you want to delete this item?
                    <br />
                    <small className="text-danger">This action cannot be undone.</small>
                  </p>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>

                  <button type="button" className="btn btn-danger" onClick={handleDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  )
}

export default Pod_details
